import { neutral3, neutral4, white } from '../../colors';
import { shadowLevel1 } from '../../shadows';

export const classes = {
  rounded: {
    borderRadius: 4,
  },
  elevation1: {
    boxShadow: shadowLevel1,
    border: `1px solid ${neutral3}`,
  },
  elevation8: {
    border: `1px solid ${neutral4}`,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    backgroundColor: white,
  },
};
